import { render, staticRenderFns } from "./overseasDetail.vue?vue&type=template&id=65a1d606&scoped=true"
import script from "./overseasDetail.vue?vue&type=script&lang=js"
export * from "./overseasDetail.vue?vue&type=script&lang=js"
import style0 from "./overseasDetail.vue?vue&type=style&index=0&id=65a1d606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a1d606",
  null
  
)

export default component.exports